import styled, { css } from "styled-components";
import ProductCard from "./ProductCard";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "./category.css";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { slugify } from "../../utils/slug";

const ProductsHero = styled.div`
  margin-bottom: 75px;
  @media only screen and (min-width: 768px) {
    margin-top: 30px;
    opacity: 1;
    transition: opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
`;

const ProductsHeroNavigationTabsContainer = styled.div`
  display: block;
  margin-right: auto;
  margin-left: auto;
  margin-top: 55px;
  width: 100%;
  text-align: center;
  @media only screen and (max-width: 1024px) {
    width: 80%;
  }
  @media screen and (max-width: 1030px) {
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }
  @media screen and (max-width: 1170px) {
    margin-top: 0;
  }
  ul {
    @media screen and (max-width: 768px) {
      overflow-x: scroll;
    }
  }
`;

const ProductsTabs = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1170px;
  min-height: 500px;
  background: #fff;
  padding-top: 32px;
`;

const ProductsCategory = styled.div`
  width: calc(100% - 40px);
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
  @media only screen and (min-width: 1210px) {
    width: 100%;
    margin: 90px auto 210px;
  }
`;

const ProductsCategoryContainer = styled.div`
  margin-left: -40px;
  margin-top: -25px;
  @media only screen and (min-width: 1210px) {
    margin-left: -80px;
    margin-top: -30px;
  }
`;

export default function ProductTabs({ data }) {
  const { category, subcategory } = useParams();
  const navigate = useNavigate();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const handleSelectTab = useCallback(
    (index) => {
      setActiveTabIndex(index);

      if (!category || !data.length) {
        return;
      }

      const categorySlug = slugify(category);

      const subcategories = data[0]?.subcategory ?? [];

      if (index === 0 || !subcategories.length) {
        if (categorySlug) {
          navigate(`/productos/${categorySlug}`);
        }
        return;
      }

      const selectedSubcategory = subcategories[index - 1];

      if (selectedSubcategory) {
        navigate(
          `/productos/${categorySlug}/${slugify(selectedSubcategory.name)}`
        );
      } else {
        navigate(`/productos/${categorySlug}`);
      }
    },
    [category, data, navigate]
  );

  useEffect(() => {
    setIsLoading(true);

    if (!data.length) {
      setActiveTabIndex(0);
      setIsLoading(false);
      return;
    }

    if (!subcategory) {
      setActiveTabIndex(0);
      setIsLoading(false);
      return;
    }

    const normalizedSubcat = slugify(subcategory);
    const subcategories = data[0]?.subcategory ?? [];
    const matchedIndex =
      subcategories.findIndex(
        (el) => slugify(el.name) === normalizedSubcat
      ) + 1;

    setActiveTabIndex(matchedIndex > 0 ? matchedIndex : 0);
    setIsLoading(false);
  }, [subcategory, data]);

  return (
    <>
      <ProductsHero>
        <ProductsHeroNavigationTabsContainer>
          <ProductsTabs>
            {!isLoading && (
              <TabsItem
                data={data}
                selectedTabIndex={activeTabIndex}
                onSelectTab={handleSelectTab}
              />
            )}
          </ProductsTabs>
        </ProductsHeroNavigationTabsContainer>
      </ProductsHero>
    </>
  );
}
const TabsItem = ({ data, selectedTabIndex, onSelectTab }) => {
  const allProducts = data[0]["subcategory"].reduce((acc, subcat) => {
    if (Array.isArray(subcat.products)) {
      return acc.concat(subcat.products);
    }
    return acc;
  }, []);

  return (
    <Tabs
      selectedTabClassName="active"
      selectedIndex={selectedTabIndex}
      onSelect={(index) => {
        onSelectTab(index);
        return true;
      }}
    >
      <TabList className="tab-list">
        <Tab className={`tab-item`}>Todos</Tab>
        {data[0]["subcategory"].map((el, idx) => (
          <Tab key={idx} className={`tab-item`}>
            {el.name}
          </Tab>
        ))}
      </TabList>

      <TabPanel key="all-products">
        <ProductsCategory>
          <ProductsCategoryContainer>
            {allProducts.map((product) => {
              const img = product.cover_image
                ? `/public/${product.cover_image}`
                : require("../../images/product/product-cover.jpg");
              return (
                <ProductCard
                  key={product.product_code}
                  product_code={product.product_code}
                  image={img}
                  product_name={product.product_code}
                  description={product.short_description}
                />
              );
            })}
          </ProductsCategoryContainer>
        </ProductsCategory>
      </TabPanel>

      {data[0]["subcategory"].map((el, idx) => (
        <TabPanel key={`${el.name}-${idx}`}>
          <ProductsCategory>
            <ProductsCategoryContainer>
              {el.products.map((i) => {
                const img = i.cover_image
                  ? `/public/${i.cover_image}`
                  : require("../../images/product/product-cover.jpg");
                return (
                  <ProductCard
                    key={i.product_code}
                    product_code={i.product_code}
                    image={img}
                    product_name={i.product_code}
                    description={i.short_description}
                  />
                );
              })}
            </ProductsCategoryContainer>
          </ProductsCategory>
        </TabPanel>
      ))}
    </Tabs>
  );
};
